module.exports = __webpack_public_path__ + "img/twitter.7468d40d.svg";